import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

interface Props {
  toggleOptions: string[];
  selectedOption: string;
  setSelectedOption: (value: string) => void;
}

export const EnrollmentDetailsToggler: React.FC<Props> = ({
  toggleOptions,
  selectedOption,
  setSelectedOption,
}) => {
  const isSelectedOption = (option: string) => option === selectedOption;
  return (
    <Box
      data-testid="MakeContributionModalToggler_container"
      direction="row"
      gap="spacing8"
      margin={{ bottom: 'spacing24' }}
      pad="spacing4"
      background={{ color: 'module' }}
      round="container1Round"
      width={{ max: 'fit-content' }}
    >
      {toggleOptions.map((option) => (
        <Box
          data-testid="MakeContributionModalToggler_item"
          key={option}
          pad={{ horizontal: 'spacing24', vertical: 'spacing12' }}
          align="center"
          justify="center"
          height={{ max: '40px' }}
          background={{ color: isSelectedOption(option) ? 'canvas' : 'transparent' }}
          border={{ color: isSelectedOption(option) ? 'border2' : 'transparent', size: 'small' }}
          round="container2Round"
          onClick={() => setSelectedOption(option)}
          style={{ cursor: 'pointer' }}
        >
          <Text
            weight={isSelectedOption(option) ? 700 : 400}
            color={isSelectedOption(option) ? 'textBody' : 'textAccent'}
          >
            {option}
          </Text>
        </Box>
      ))}
    </Box>
  );
};
